import { action } from 'satcheljs';
import type { ActionMessage } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export interface OnBriefingDraftReplySentActionMessage extends ActionMessage {
    itemId: string;
    mailboxInfo: MailboxInfo;
    briefingId?: string;
}

/**
 * Fired when the user sends a reply pre-drafted from a MyOutlook briefing item.
 * The PersonalOS store listens and marks the originating item done via
 * `PATCH /pos/briefing/actions {op:'done'}`. `itemId` is the D2
 * briefing-projection id; `briefingId` identifies the briefing that displayed it.
 */
export const onBriefingDraftReplySent: (
    itemId: string,
    mailboxInfo: MailboxInfo,
    briefingId?: string
) => OnBriefingDraftReplySentActionMessage = action(
    'onBriefingDraftReplySent',
    (itemId: string, mailboxInfo: MailboxInfo, briefingId?: string) => ({
        itemId,
        mailboxInfo,
        briefingId,
    })
);
